import { NoOpsSelected, PageError, PageLoading } from '../../../../components';
import {
  AntecipacaoHeader,
  AntecipacaoSummaryCards,
  AntecipacaoTable,
} from './components';
import { useAntecipacao } from './hooks/use-antecipacao';

export function RomaneioAntecipacao() {
  const {
    currentOps,
    data,
    loading,
    isFetching,
    error,
    selectedDate,
    columns,
    formatCurrency,
    handleDateChange,
    loadData,
  } = useAntecipacao();

  if (!currentOps) {
    return (
      <NoOpsSelected message="Selecione uma operação para visualizar as antecipações." />
    );
  }

  return (
    <div className="space-y-6">
      <AntecipacaoHeader
        selectedDate={selectedDate}
        onDateChange={handleDateChange}
        onRefresh={loadData}
        isRefreshing={isFetching}
      />

      <PageError error={error} />

      <PageLoading loading={loading} />

      {!loading && data && (
        <>
          <AntecipacaoSummaryCards
            summary={data.summary}
            formatCurrency={formatCurrency}
          />
          <AntecipacaoTable data={data.antecipacoes ?? []} columns={columns} />
        </>
      )}
    </div>
  );
}
